import React, { FC, useCallback, useState } from 'react';
import { Icons } from '../SvgIcon';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '../../../security/components';
import { PageTitle, PageTitleIconPrefix } from '../PageTitle';
import PublicPageFooter from '../../../app/components/PublicPageFooter';
import { shouldIncludeSmartSchoolButton } from '../../helpers/smartschool';
import { Padding4Rem, StyledContent, StyledPaper, TabletHeader, TabletLogo } from './Atoms';
import { PublicPagesInfo } from './PublicPagesInfo';
import { LoginButtons } from '../../../security/components/login-buttons';
import { Button } from '@material-ui/core';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { useTheme } from '@material-ui/core';

type TabletLoginInfoWrapperProps = {
  mobile: boolean;
};

export const TabletLoginInfoWrapper: FC<TabletLoginInfoWrapperProps> = ({ mobile }) => {
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = useState(false);
  const theme = useTheme();

  const toggleShowLogin = useCallback(() => {
    setShowLogin((prev) => !prev);
  }, []);

  return showLogin ? (
    <StyledPaper className={'full-size'}>
      <StyledContent>
        <TabletHeader>
          <TabletLogo id="logo" size={mobile ? 'normal' : 'large'} />
          <Button
            variant="text"
            onClick={toggleShowLogin}
            disableElevation
            startIcon={
              <FontAwesomeSpriteIcon
                icon={SpriteIconsLight.BACK_BUTTON}
                iconSize="sm"
                color={theme.palette.secondary.main}
              />
            }
          >
            {t('shared.back')}
          </Button>
        </TabletHeader>
        <PageTitle prefix={<PageTitleIconPrefix icon={Icons.USER} />} forceInline>
          {t('security.login.pageTitle')}
        </PageTitle>
        <LoginForm />
      </StyledContent>
      {shouldIncludeSmartSchoolButton() && <LoginButtons />}
      <PublicPageFooter />
    </StyledPaper>
  ) : (
    <Padding4Rem>
      <TabletHeader>
        <TabletLogo id="logo" size="large" />
        <Button
          onClick={toggleShowLogin}
          variant="contained"
          color="primary"
          disableElevation
          startIcon={
            <FontAwesomeSpriteIcon
              icon={SpriteIconsLight.SUBMIT}
              iconSize="sm"
              color={theme.palette.secondary.main}
            />
          }
        >
          {t('security.login.loginBtn')}
        </Button>
      </TabletHeader>
      <PublicPagesInfo />
      <PublicPageFooter />
    </Padding4Rem>
  );
};
